// test1276
(1276 && 0);
